import { ModalController, NavController } from "@ionic/angular";
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  NgZone,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { MatSelect } from "@angular/material/select";
import { Storage } from "@ionic/storage";
import { ToastController, LoadingController } from "@ionic/angular";
import { Network } from "@ionic-native/network/ngx";
import { Helper } from "../services/Helper";
import { APIService } from "../services/APIService";
import { Register } from "../models/Register";
import { ReplaySubject, Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";

interface state {
  _id: number;
  StateName: string;
}

interface city {
  _id: number;
  CityName: string;
}

@Component({
  selector: "app-filter",
  templateUrl: "./filter.page.html",
  styleUrls: ["./filter.page.scss"],
})
export class FilterPage implements OnInit {
  credentialsForm: FormGroup;
  Regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  selected: any;
  states: state[];
  citys: city[];
  loader: any;

  public stateCtrl: FormControl = new FormControl();
  public cityCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword */
  public stateFilterCtrl: FormControl = new FormControl();
  public cityFilterCtrl: FormControl = new FormControl();

  /** list of states filtered by search keyword */
  public filteredstates: ReplaySubject<state[]> = new ReplaySubject<state[]>(1);
  public filteredcitys: ReplaySubject<city[]> = new ReplaySubject<city[]>(1);

  @ViewChild("singleSelect", { static: true }) singleSelect: MatSelect;
  @ViewChild("singleSelect1", { static: true }) singleSelect1: MatSelect;

  protected _onDestroy = new Subject<void>();

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private router: Router,
    private storage: Storage,
    public toastController: ToastController,
    private network: Network,
    public loadingController: LoadingController,
    public helper: Helper,
    private apiservice: APIService,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.apiservice.getStates().subscribe(
      (response) => {
        this.states = response.body.State;
        console.log("all states", this.states);

        this.stateCtrl.setValue(this.states[0]);

        // load the initial state list
        this.filteredstates.next(this.states.slice());

        // listen for search field value changes
        this.stateFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterstates();
          });
      },
      (error) => {
        console.log("error is fetching states");
      }
    );

    this.apiservice.getcitys({ StateId: 0 }).subscribe(
      (response) => {
        this.citys = response.body.City;
        console.log("all citys", this.citys);

        this.cityCtrl.setValue(this.citys[0]);

        // load the initial city list
        this.filteredcitys.next(this.citys.slice());

        // listen for search field value changes
        this.cityFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtercitys();
          });
      },
      (error) => {
        console.log("error is fetching citys");
      }
    );
  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  /**
   * Sets the initial value after the filteredstates are loaded initially
   */
  protected setInitialValue() {
    this.filteredstates
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect.compareWith = (a: state, b: state) =>
          a && b && a._id === b._id;
      });

    this.filteredcitys
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect.compareWith = (a: city, b: city) =>
          a && b && a._id === b._id;
      });
  }

  protected filterstates() {
    console.log(this.stateFilterCtrl.value);

    if (!this.states) {
      return;
    }
    // get the search keyword
    let search = this.stateFilterCtrl.value;
    if (!search) {
      this.filteredstates.next(this.states.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the states
    this.filteredstates.next(
      this.states.filter(
        (state) => state.StateName.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected filtercitys() {
    console.log(this.cityFilterCtrl.value);

    if (!this.citys) {
      return;
    }
    // get the search keyword
    let search = this.cityFilterCtrl.value;
    if (!search) {
      this.filteredcitys.next(this.citys.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the citys
    this.filteredcitys.next(
      this.citys.filter(
        (city) => city.CityName.toLowerCase().indexOf(search) > -1
      )
    );
  }

  ionViewWillEnter() {}

  // MAIN PART
  getDoctors() {
    // console.log(this.cityCtrl.value._id);
    this.modalCtrl.dismiss(this.cityCtrl.value._id);
  }

  dismiss() {
    this.modalCtrl.dismiss({
      dismissed: true,
    });
  }

  login() {
    this.router.navigate(["/login"]);
  }

  onStateChange(event) {
    console.log(event.value._id);

    this.apiservice.getcitys({ StateId: event.value._id }).subscribe(
      (response) => {
        this.citys = response.body.City;
        console.log("all citys", this.citys);

        this.cityCtrl.setValue(this.citys[0]);

        // load the initial city list
        this.filteredcitys.next(this.citys.slice());

        // listen for search field value changes
        this.cityFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtercitys();
          });
      },
      (error) => {
        console.log("error is fetching citys");
      }
    );
  }

  async presentLoading() {
    this.loader = await this.loadingController.create({
      translucent: true,
    });
    await this.loader.present();
  }

  async dismissLoading() {
    await this.loader.dismiss();
  }
}
